// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-selector {
  background-color: var(--ion-background-color);
  z-index: 100;
}

.group-cover {
  display: flex;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  background-color: var(--ion-background-color);
  color: var(--ion-text-color);
  margin-left: 3px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.group-selected {
  background-color: #D06740;
  border-radius: 4px;
  color: white;
}

.group-item {
  padding: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  white-space: nowrap;
  height: 44px;
  align-items: center;
  display: flex;
  justify-content: center;
  scroll-snap-align: start;
}

.sub-group-item {
  padding: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  white-space: nowrap;
  height: 40px;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 14px;
}

.sub-group-selected {
  border: 5px solid white;
  border-radius: 5px;
  color: #7b371d;
  background: white;
  border-bottom-color: #D06740;
}

.sub-group-cover {
  display: flex;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  background-color: var(--ion-background-color);
  color: var(--ion-text-color);
  margin: 10px 0 10px 3px;
  background: whitesmoke;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  border-radius: 10px 0 0 10px;
}

.golden-btn + .golden-btn {
  margin-top: 1em;
}

.golden-btn {
  display: inline-block;
  outline: none;
  font-family: inherit;
  font-size: 1em;
  box-sizing: border-box;
  border: none;
  border-radius: 0.3em;
  height: 2.75em;
  line-height: 2.5em;
  text-transform: uppercase;
  padding: 0 1em;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(110, 80, 20, 0.4), inset 0 -2px 5px 1px rgb(139, 66, 8), inset 0 -1px 1px 3px rgb(250, 227, 133);
  background-image: linear-gradient(160deg, #a54e07, #b47e11, #fef1a2, #bc881b, #a54e07);
  border: 1px solid #a55d07;
  color: rgb(120, 50, 5);
  text-shadow: 0 2px 2px rgb(250, 227, 133);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-size: 100% 100%;
  background-position: center;
}

.golden-btn:focus,
.golden-btn:hover {
  background-size: 150% 150%;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23), inset 0 -2px 5px 1px #b17d10, inset 0 -1px 1px 3px rgb(250, 227, 133);
  border: 1px solid rgba(165, 93, 7, 0.6);
  color: rgba(120, 50, 5, 0.8);
}

.golden-btn:active {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(110, 80, 20, 0.4), inset 0 -2px 5px 1px #b17d10, inset 0 -1px 1px 3px rgb(250, 227, 133);
}

.group-disabled {
  filter: opacity(0.3) grayscale(1);
}

.search-bar {
  transition: width 1s;
}

.search-bar-active {
  width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu/group-selector/group-selector.component.scss"],"names":[],"mappings":"AAAA;EAEI,6CAAA;EACA,YAAA;AAAJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,4BAAA;EACA,gBAAA;EAEA,uBAAA;EACA,iCAAA;AAFJ;;AAMA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;AAHJ;;AAMA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,mBAAA;EAEA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,wBAAA;AALJ;;AAQA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,mBAAA;EAEA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAPJ;;AAUA;EAEI,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,4BAAA;AARJ;;AAWA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,4BAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iCAAA;EACA,4BAAA;AARJ;;AAWA;EACI,eAAA;AARJ;;AAWA;EACI,qBAAA;EACA,aAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,0JAAA;EAEA,sFAAA;EACA,yBAAA;EACA,sBAAA;EACA,yCAAA;EACA,eAAA;EACA,gCAAA;EACA,0BAAA;EACA,2BAAA;AATJ;;AAYA;;EAEI,0BAAA;EACA,iJAAA;EAEA,uCAAA;EACA,4BAAA;AAVJ;;AAaA;EACI,kJAAA;AAVJ;;AAeA;EACI,iCAAA;AAZJ;;AAeA;EACI,oBAAA;AAZJ;;AAeA;EACI,YAAA;AAZJ","sourcesContent":[".group-selector {\n\n    background-color: var(--ion-background-color);\n    z-index: 100;\n\n}\n\n.group-cover {\n    display: flex;\n    align-items: center;\n    overflow-x: scroll;\n    overflow-y: hidden;\n    background-color: var(--ion-background-color);\n    color: var(--ion-text-color);\n    margin-left: 3px;\n    //margin-top: 3px;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    //scroll-snap-type: x mandatory;\n}\n\n.group-selected {\n    background-color: #D06740;\n    border-radius: 4px;\n    color: white;\n}\n\n.group-item {\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    position: relative;\n    //background-color: var(--ion-background-color);\n    white-space: nowrap;\n    //margin-bottom: 3px;\n    height: 44px;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    scroll-snap-align: start;\n}\n\n.sub-group-item {\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    position: relative;\n    //background-color: var(--ion-background-color);\n    white-space: nowrap;\n    // margin-bottom: 3px;\n    height: 40px;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    font-size: 14px;\n}\n\n.sub-group-selected {\n    // border-bottom: 4px solid #D06740;\n    border: 5px solid white;\n    border-radius: 5px;\n    color: #7b371d;\n    background: white;\n    border-bottom-color: #D06740;\n}\n\n.sub-group-cover {\n    display: flex;\n    align-items: center;\n    overflow-x: scroll;\n    overflow-y: hidden;\n    background-color: var(--ion-background-color);\n    color: var(--ion-text-color);\n    margin: 10px 0 10px 3px;\n    background: whitesmoke;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    border-radius: 10px 0 0 10px;\n}\n\n.golden-btn+.golden-btn {\n    margin-top: 1em;\n}\n\n.golden-btn {\n    display: inline-block;\n    outline: none;\n    font-family: inherit;\n    font-size: 1em;\n    box-sizing: border-box;\n    border: none;\n    border-radius: 0.3em;\n    height: 2.75em;\n    line-height: 2.5em;\n    text-transform: uppercase;\n    padding: 0 1em;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(110, 80, 20, 0.4),\n        inset 0 -2px 5px 1px rgba(139, 66, 8, 1), inset 0 -1px 1px 3px rgba(250, 227, 133, 1);\n    background-image: linear-gradient(160deg, #a54e07, #b47e11, #fef1a2, #bc881b, #a54e07);\n    border: 1px solid #a55d07;\n    color: rgb(120, 50, 5);\n    text-shadow: 0 2px 2px rgba(250, 227, 133, 1);\n    cursor: pointer;\n    transition: all 0.2s ease-in-out;\n    background-size: 100% 100%;\n    background-position: center;\n}\n\n.golden-btn:focus,\n.golden-btn:hover {\n    background-size: 150% 150%;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23), inset 0 -2px 5px 1px #b17d10,\n        inset 0 -1px 1px 3px rgba(250, 227, 133, 1);\n    border: 1px solid rgba(165, 93, 7, 0.6);\n    color: rgba(120, 50, 5, 0.8);\n}\n\n.golden-btn:active {\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(110, 80, 20, 0.4), inset 0 -2px 5px 1px #b17d10,\n        inset 0 -1px 1px 3px rgba(250, 227, 133, 1);\n}\n\n\n.group-disabled {\n    filter: opacity(0.3) grayscale(1);\n}\n\n.search-bar {\n    transition: width 1s;\n}\n\n.search-bar-active {\n    width: 300px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
